import { useSelector } from "react-redux"
import { selectUserGroups } from "lib/store/services/auth/selectors"

export const useUserGroups = () => {
  const userGroups = useSelector(selectUserGroups)

  const hasGroup = (group: string): boolean => {
    return userGroups?.includes(group) || false
  }

  const hasAnyGroup = (groups: string[]): boolean => {
    return groups.some((group) => userGroups?.includes(group))
  }

  const hasAllGroups = (groups: string[]): boolean => {
    return groups.every((group) => userGroups?.includes(group))
  }

  // Legacy groups
  const isSuperUser = userGroups?.includes("brinkcommerce-superuser") || false
  const isUserAdmin = userGroups?.includes("brinkcommerce-useradmin") || false
  const isCampaignUser = userGroups?.includes("brinkcommerce-campaignuser") || false
  const isReadOnlyUser = userGroups?.includes("brinkcommerce-readonly") || false

  // New groups
  const isCxUser = userGroups?.includes("cx-user") || false
  const isCxAdmin = userGroups?.includes("cx-admin") || false
  const isEcomUser = userGroups?.includes("ecom-user") || false
  const isEcomAdmin = userGroups?.includes("ecom-admin") || false
  const isSystemUser = userGroups?.includes("system-user") || false
  const isSystemAdmin = userGroups?.includes("system-admin") || false

  return {
    userGroups,
    hasGroup,
    hasAnyGroup,
    hasAllGroups,
    // Legacy groups
    isSuperUser,
    isUserAdmin,
    isCampaignUser,
    isReadOnlyUser,
    // New groups
    isCxUser,
    isCxAdmin,
    isEcomUser,
    isEcomAdmin,
    isSystemUser,
    isSystemAdmin,
  }
}